// Add styling to the timeline when the user scrolls past it
window.addEventListener('scroll', function() {
  let element = document.getElementById('timeline-key');

  if (window.scrollY == element.offsetTop) {
    element.classList.add('border');
  } else {
    element.classList.remove('border');
  }
});
